import * as extensions from './matchers';
export * from './types';

expect.extend(extensions);
